import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api, { vnayaApi } from '../../Api/api';

/* =======================
   ASYNC API CALL
======================= */
export const fetchUserActionLogs = createAsyncThunk(
  'userActionLogs/fetchUserActionLogs',
  async ({params,type}, { rejectWithValue }) => {
    try {
      const { data } = (type!=='vnaya')?await api.get((type==='broker')?'/users/user-action-logs-all':'/api/carrier-action-logs-all', {
        params,
      }):await vnayaApi.get('/user-action-logs-all', {
        params,
      });
      return {data,type};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const sendSlientNotification = createAsyncThunk(
  'userActionLogs/sendSlientNotification',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/send-silent-push-all-users');
      console.log("silent push===>",data);
      
      return data;
    } catch (err) {
      console.log("silent push err===>",err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/* =======================
   INITIAL STATE
======================= */
const initialState = {
  logdata:null,
  clogdata:null,
  vnayalogdata:null,
  loading: false,
  error: null,
};

/* =======================
   SLICE
======================= */
const userActionLogsSlice = createSlice({
  name: 'userActionLogs',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUserActionLogs.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserActionLogs.fulfilled, (state, action) => {
        if(action.payload.type==='broker'){
          state.logdata = action.payload.data;
        }
        if(action.payload.type==='carrier'){
          state.clogdata = action.payload.data;
        }
        if(action.payload.type==='vnaya'){
          state.vnayalogdata = action.payload.data;
        }
        state.loading = false;
      })
      .addCase(fetchUserActionLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userActionLogsSlice.reducer;
